export const enUS = {
  agree: 'I/We agree to allow the use of my/our personal data to receiving ',
  directMarketing: 'direct marketing',
  period: ' materials concerning the latest offers, promotions, product information or updates',
  yes: 'Yes',
  no: 'No',
}
